
// Public
import { PublicRoutes } from 'modules/Public';

import { Routes as Dashboard } from 'modules/Admin/Dashboard';
import { Routes as Profile } from 'modules/Admin/Profile';
import { Routes as Accounts } from 'modules/Admin/Accounts';
import { Routes as Companies } from 'modules/Admin/Companies';
import { Routes as Employees } from 'modules/Admin/Employees';
import { Routes as Inventory } from 'modules/Admin/Inventory';
import { Routes as Reports } from 'modules/Admin/Reports';

// -------

const routes = {
  public: { ...PublicRoutes },

  dashboard: { ...Dashboard },
  profile: { ...Profile },
  accounts: { ...Accounts },
  companies: { ...Companies },
  employees: { ...Employees },
  inventory: { ...Inventory },
  reports: { ...Reports },
}
console.log('ROOT: Routes', routes)

export default routes;
